import React, { useRef,useEffect } from 'react'
import './index.scss'
// import QRCode from 'qrcode.react';
import html2canvas from 'html2canvas';
// import {showToast} from '@/components/toast'
import {fleetinfoAction} from '@/store/actions/fleetinfoAction'
import {connect} from 'react-redux'

const mapStateToProps = (state) => ({
    //邀请链接
    fleetQrCodeUrl : state.getIn(['fleetinfoReducer', 'fleetQrCodeUrl']),
    //司管名称
    fleetManagerName : state.getIn(['fleetinfoReducer', 'fleetManagerName']),
    //司管电话
    fleetManagerPhone : state.getIn(['fleetinfoReducer', 'fleetManagerPhone']),
})
const mapDispatchToProps = (dispatch) => ({
    //车队信息总览
    handleGetFleetInfo(){
        return dispatch(fleetinfoAction());
    }

})
const FleetManage = (props) => {
    let {handleGetFleetInfo,fleetQrCodeUrl,fleetManagerName,fleetManagerPhone} = props
    // 获取截图二维码
    let qcCode = useRef();
    const handleOnSavePhone = () => {
        //截图
        html2canvas(qcCode.current, {
            allowTaint: false,
            useCORS: true,
            scale: 2,
            // imageTimeout : 10000,
            dpi: window.devicePixelRatio * 2
        }).then(function (canvas) {
            let d = canvas.toDataURL('image/png');
            //截取只保留base64 字符串
            let packD = d.substring(d.indexOf(',') + 1);
            // 截图成功
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            let params = {
                title: 'img',
                url: packD
            }
            if (isAndroid) {
                window.savePicture.onSavePicture(packD);
            } else if (isIOS) {
                window.WebViewJavascriptBridge.callHandler('handleSavePhone', params);
            }
            // 保存成功
            // showToast('图片保存成功')
        })
    }
    useEffect(() => {
        //获取车队信息
        handleGetFleetInfo();
        return () => {}
    }, [handleGetFleetInfo])
    return (
        <div className="fleet-manage__box">
            <div className="fleet-manage-info">
                <h3 style={{borderTop:0}}>
                    <em>司管姓名: </em><b>{fleetManagerName}</b>
                </h3>
                <h3>
                    <em>司管电话: <b>{fleetManagerPhone}</b></em>
                    <a href={`tel:${fleetManagerPhone}`}><i className="iconfont icon-dianhua01"></i></a>
                </h3>
                <h3>
                    <em>车队二维码: </em>
                    <div className='qrcode-box' ref={qcCode}>
                        {/* <QRCode
                            value={fleetQrCodeUrl}  //value参数为生成二维码的链接
                            fgColor="#000000"  //二维码的颜色
                        /> */}
                        <img src={fleetQrCodeUrl} alt="" />
                    </div>
                </h3>
            </div>
            <footer>
                <button onClick={handleOnSavePhone} style={(React.colorConfig ? React.colorConfig.buttonBg : {})}>保存二维码图片</button>
            </footer>
        </div>
    )
}
export default connect(mapStateToProps,mapDispatchToProps)(FleetManage)
